import { sbaAxios } from "../utils/sbaAxios";
import { getProformas, getProformaOptions, getProforma, getEntities } from "../../config/apiConfig";
import {
  FETCH_PROFORMACONSTRUCTION_BEGIN,
  FETCH_PROFORMALISTS_SUCCESS,
  FETCH_PROFORMADATE_SUCCESS,
  FETCH_PROFORMAREBALANCEMETHOD_SUCCESS,
  FETCH_PROFORMABACKFILL_SUCCESS,
  FETCH_PROFORMATREELIST_SUCCESS,
  FETCH_PROFORMAENTITIES_SUCCESS,
  FETCH_PROFORMACONSTRUCTION_FAILURE,
  } from '../constants/Proforma';

// Lists Grid
export const getProformaListAction =  ()=> {
   return  (dispatch) => {
       dispatch(fetchProformaActionBegin());
       sbaAxios({
           url: `${getProformas}`,
           method: 'get',
       })
      .then((repos) => {
        const ProformaList = repos;
        dispatch(fetchProformaActionSuccess(ProformaList));
        return ProformaList;
      })
      .catch((error) =>{ return dispatch(fetchProformaActionFailure(error))});
  };
}

export const fetchProformaActionSuccess = (ProformaListData) => ({
  type: FETCH_PROFORMALISTS_SUCCESS,
  payload: {ProformaListData},
});

export const getProformaDateAction =  (optionType)=> {
  return  (dispatch) => {
      dispatch(fetchProformaActionBegin());
      sbaAxios({
          url: `${getProformaOptions}/${optionType}`,
          method: 'get',
      })
     .then((repos) => {
       const ProformaDate = repos;
       dispatch(fetchProformaDateActionSuccess(ProformaDate));
       return ProformaDate;
     })
     .catch((error) =>{ return dispatch(fetchProformaActionFailure(error))});
 };
}

export const fetchProformaDateActionSuccess = (ProformaDateData) => ({
  type: FETCH_PROFORMADATE_SUCCESS,
  payload: {ProformaDateData},
});

export const getProformaRebalanceAction =  (optionType)=> {
  return  (dispatch) => {
      dispatch(fetchProformaActionBegin());
      sbaAxios({
          url: `${getProformaOptions}/${optionType}`,
          method: 'get',
      })
     .then((repos) => {
       const ProformaRebalance = repos;
       dispatch(fetchProformaRebalanceActionSuccess(ProformaRebalance));
       return ProformaRebalance;
     })
     .catch((error) =>{ return dispatch(fetchProformaActionFailure(error))});
 };
}

export const fetchProformaRebalanceActionSuccess = (ProformaRebalanceData) => ({
  type: FETCH_PROFORMAREBALANCEMETHOD_SUCCESS,
  payload: {ProformaRebalanceData},
});

export const getProformaBackfillAction =  (optionType)=> {
  return  (dispatch) => {
      dispatch(fetchProformaActionBegin());
      sbaAxios({
          url: `${getProformaOptions}/${optionType}`,
          method: 'get',
      })
     .then((repos) => {
       const ProformaBackfill = repos;
       dispatch(fetchProformaBackfillActionSuccess(ProformaBackfill));
       return ProformaBackfill;
     })
     .catch((error) =>{ return dispatch(fetchProformaActionFailure(error))});
 };
}

export const fetchProformaBackfillActionSuccess = (ProformaBackfillData) => ({
  type: FETCH_PROFORMABACKFILL_SUCCESS,
  payload: {ProformaBackfillData},
});

export const getProformaTreeListAction =  (proformaId )=> {
  return  (dispatch) => {
      dispatch(fetchProformaActionBegin());
      sbaAxios({
          url: `${getProforma}/${proformaId }`,
          method: 'get',
      })
     .then((repos) => {
       const ProformaTreeList = repos;
       dispatch(fetchProformaTreeListActionSuccess(ProformaTreeList));
       return ProformaTreeList;
     })
     .catch((error) =>{ return dispatch(fetchProformaActionFailure(error))});
 };
}

export const fetchProformaTreeListActionSuccess = (ProformaTreeListData) => ({
  type: FETCH_PROFORMATREELIST_SUCCESS,
  payload: {ProformaTreeListData},
});

export const getProformaEntitiesAction =  (searchFor, isContains, type)=> {
  return  (dispatch) => {
      dispatch(fetchProformaActionBegin());
      sbaAxios({
          url: `${getEntities}/${searchFor},${isContains},${type}`,
          method: 'get',
      })
     .then((repos) => {
       const ProformaEntities = repos;
       dispatch(fetchProformaEntitiesActionSuccess(ProformaEntities));
       return ProformaEntities;
     })
     .catch((error) =>{ return dispatch(fetchProformaActionFailure(error))});
 };
}

export const fetchProformaEntitiesActionSuccess = (ProformaEntitiesData) => ({
  type: FETCH_PROFORMAENTITIES_SUCCESS,
  payload: {ProformaEntitiesData},
});

export const fetchProformaActionBegin = () => ({
  type: FETCH_PROFORMACONSTRUCTION_BEGIN,
});

export const fetchProformaActionFailure = (errorMessage) => ({
  type: FETCH_PROFORMACONSTRUCTION_FAILURE,
  payload: {errorMessage}
});